<div class="mat-small status-label" [style]="getItemStyle()">{{ getText() }}</div>
